import { render, staticRenderFns } from "./ngos-data-list.vue?vue&type=template&id=5313db06&"
import script from "./ngos-data-list.vue?vue&type=script&lang=js&"
export * from "./ngos-data-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports